const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';
const SESSAO_EXPIRA_EM_KEY = 'sessaoExpiraEm';

export function isAuthenticated() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setTokens(accessToken, refreshToken, sessaoExpiraEm = null) {
    if (accessToken) localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    if (refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    if (sessaoExpiraEm) localStorage.setItem(SESSAO_EXPIRA_EM_KEY, sessaoExpiraEm);
}

export function login(accessToken, refreshToken, sessaoExpiraEm = null) {
    setTokens(accessToken, refreshToken, sessaoExpiraEm);
}

export function getSessaoExpiraEm() {
    return localStorage.getItem(SESSAO_EXPIRA_EM_KEY);
}

export function clearTokens() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(SESSAO_EXPIRA_EM_KEY);
}

export function logout() {
    clearTokens();
    localStorage.removeItem('usuarioLogado');
    localStorage.removeItem('nomeUsuario');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('trocarSenha');
    localStorage.removeItem('perfis');
    localStorage.removeItem('cpf');
    localStorage.removeItem('crm');
    localStorage.removeItem('usuarioId');
}

export function saveUsuarioLogado(email) {
    localStorage.setItem('usuarioLogado', email);
}

export function saveCandidatoId(id) {
    localStorage.setItem('candidatoId', id || '');
}

export function getCandidatoId() {
    return localStorage.getItem('candidatoId') || '';
}

export function saveUsuarioId(id) {
    localStorage.setItem('usuarioId', id || '');
}

export function getUsuarioId() {
    return localStorage.getItem('usuarioId') || '';
}

export function saveNomeUsuario(nome) {
    localStorage.setItem('nomeUsuario', nome || '');
}

export function getNomeUsuario() {
    return localStorage.getItem('nomeUsuario') || '';
}

export function saveIsAdmin(isAdmin) {
    localStorage.setItem('isAdmin', isAdmin ? 'true' : 'false');
}

export function getIsAdmin() {
    return localStorage.getItem('isAdmin') === 'true';
}

export function saveTrocarSenha(trocarSenha) {
    localStorage.setItem('trocarSenha', trocarSenha ? 'true' : 'false');
}

export function getTrocarSenha() {
    return localStorage.getItem('trocarSenha') === 'true';
}

export function getUsuarioLogado() {
    return localStorage.getItem('usuarioLogado') || '';
}

export function savePerfis(perfis) {
    localStorage.setItem('perfis', JSON.stringify(perfis || []));
}

export function getPerfis() {
    try {
        return JSON.parse(localStorage.getItem('perfis')) || [];
    } catch {
        return [];
    }
}

export function temPerfil(perfil) {
    return getPerfis().includes(perfil);
}

export function saveCpf(cpf) {
    localStorage.setItem('cpf', cpf || '');
}

export function getCpf() {
    return localStorage.getItem('cpf') || '';
}

export function saveCrm(crm) {
    localStorage.setItem('crm', crm || '');
}

export function getCrm() {
    return localStorage.getItem('crm') || '';
}


